export const GET_TRANSACTION = 'BILLS/get_transaction';
export const SHOW_TRANSACTION = 'BILLS/show_transaction';

export const FORM_DATA = {
  status: 'REJECT',
  remarks: '',
};
